module.exports = __webpack_public_path__ + "static/media/i_bolt.64b3ba37.webp";